<template>
  <div>
    <v-container class="content-wrapper" fluid id="resources-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Services
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-resources
              ref="table"
              :url-api="'/api/v1/resources/provider'"
              :url-api-delete="'/api/v1/resources'"
              :url-api-copy="'/api/v1/resources'"
              :search="search"
              :search-attributes="['text']"
              @delete="deleteHandler"
              :edit-router="'ServicesEdit'"
              :overview-router="'ServicesOverview'"
              :key="tableKey"
            >
            </table-resources>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import TableResources from '@/components/resource/TableResources';

export default {
  name: 'Services',
  mixins: [util],
  components: {
    TableResources,
  },
  data: () => ({
    search: {},
    tableKey: 0,
  }),
  // created() {
  //   if (this.isFirstTime()) {
  //     this.$router.push({
  //       name: 'Marketplace',
  //     });
  //   }
  // },
  methods: {
    deleteHandler() {
      this.forceTableRerender();
    },
    forceTableRerender() {
      this.tableKey += 1;
    },
  },
};
</script>
